import {
  CardId,
  TCardSlotPosition,
  TCard,
  TCardLayoutSlot,
} from '@/console/features/card-layout/card-layout.types';

export const initialCards: TCard[] = [
  {
    id: CardId.GROUPS,
    position: {
      slot: TCardLayoutSlot.TOP,
      order: TCardSlotPosition.FIRST,
    },
  },
  {
    id: CardId.PROJECTS,
    position: {
      slot: TCardLayoutSlot.RIGHT,
      order: TCardSlotPosition.FIRST,
    },
  },
  {
    id: CardId.DEVICES,
    position: {
      slot: TCardLayoutSlot.RIGHT,
      order: TCardSlotPosition.SECOND,
    },
  },
  {
    id: CardId.PIPELINES,
    position: {
      slot: TCardLayoutSlot.BOTTOM,
      order: TCardSlotPosition.FILL,
    },
  },
];
